import { RouteRecordRaw } from 'vue-router'

const jsonform: Array<RouteRecordRaw> = [{
    path: '/jsonform',
    meta: {
        title: "患者审核"
    },
    component: () => import("@/views/jsonform/list.vue")
}];
export default jsonform;